import { useAuth } from '../../context/AuthContext';
import { Navigate, Outlet, useLocation } from 'react-router-dom';  // Import useLocation

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const isSidebarOpen = location?.state?.isSidebarOpen;  // Get isSidebarOpen from location state

  // Show a loading indicator while the auth state is being checked
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div>Loading...</div>
      </div>
    );
  }

  // If loading is done and there is a user, show the requested page
  if (user) {
    return <Outlet state={{ isSidebarOpen }} />; // Pass isSidebarOpen to Outlet
  }

  // If loading is done and there's no user, redirect to the login page
  return <Navigate to="/login" replace />;
}